// 작업지시서 가이드 SSOT manifest 런타임 로더 — SPEC-CHINA-WO-GUIDE-SSOT-001 (v0.4.0)
//
// 왜 런타임 조회인가: manifest를 빌드에 굳히면 가이드 파일명(버전)이 바뀔 때마다
// 앱 재배포가 필요하다. COS의 포인터 manifest를 클릭 시점에 조회하면
// 가이드 개정이 "COS 업로드 + 포인터 manifest 교체"만으로 끝난다(완전 무배포).
//
// 폴백 체인: COS 포인터(2초 타임아웃) → 번들 manifest → 각 버튼의 하드코딩 키.
// COS 포인터는 이 체계에서 유일하게 덮어쓰기가 허용되는 오브젝트다(콘텐츠는 버전 파일명 불변).
import bundledManifest from '../../docs/guides/work-order/manifest.json';

export const GUIDE_COS_BASE = 'https://dentalmax-guides-1326561935.cos.ap-shanghai.myqcloud.com';
const POINTER_URL = `${GUIDE_COS_BASE}/manifest/work-order-guide.json`;
const FETCH_TIMEOUT_MS = 2000;

let cached = null;

// 세션당 1회만 네트워크 조회하고 이후 클릭은 캐시를 쓴다.
export async function getGuideManifest() {
  if (cached) return cached;
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    const res = await fetch(POINTER_URL, { signal: controller.signal, cache: 'no-cache' });
    clearTimeout(timer);
    if (res.ok) {
      const data = await res.json();
      if (data && data.artifacts) {
        cached = data;
        return cached;
      }
    }
  } catch (e) {
    // 네트워크 실패·타임아웃 — 번들 폴백으로 조용히 넘어간다. 버튼은 죽지 않는다.
  }
  cached = bundledManifest;
  return cached;
}
